var map = {
	"./default.png": 796,
	"./diamond.jpeg": 9789,
	"./elite.jpeg": 8442,
	"./gold.png": 5501,
	"./jade.jpeg": 3749,
	"./platinum.jpeg": 853,
	"./silver.jpeg": 3936
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5661;